export const settingsSubsistenceRateConstants = {
  GET_SETTINGS_SUBSISTENCE_REQUEST_DATA: 'SETTINGS_SUBSISTENCE_REQUEST_GET_DATA',
  GET_SETTINGS_SUBSISTENCE_RATE_REQUEST: 'SETTINGS_SUBSISTENCE_RATE_GET_REQUEST',
  GET_SETTINGS_SUBSISTENCE_RATE_SUCCESS: 'SETTINGS_SUBSISTENCE_RATE_GET_SUCCESS',
  GET_SETTINGS_SUBSISTENCE_RATE_FAILURE: 'SETTINGS_SUBSISTENCE_RATE_GET_FAILURE',
  SUBSISTENCE_RATE_ADD_REQUEST: 'SETTINGS_SUBSISTENCE_RATE_ADD_REQUEST',
  SUBSISTENCE_RATE_ADD_SUCCESS: 'SETTINGS_SUBSISTENCE_RATE_ADD_SUCCESS',
  SUBSISTENCE_RATE_ADD_FAILURE: 'SETTINGS_SUBSISTENCE_RATE_ADD_FAILURE',
  SUBSISTENCE_RATE_EDIT_REQUEST: 'SETTINGS_SUBSISTENCE_RATE_EDIT_REQUEST',
  SUBSISTENCE_RATE_EDIT_SUCCESS: 'SETTINGS_SUBSISTENCE_RATE_EDIT_SUCCESS',
  SUBSISTENCE_RATE_EDIT_FAILURE: 'SETTINGS_SUBSISTENCE_RATE_EDIT_FAILURE',
  SUBSISTENCE_RATE_DELETE_REQUEST: 'SETTINGS_SUBSISTENCE_RATE_DELETE_REQUEST',
  SUBSISTENCE_RATE_DELETE_SUCCESS: 'SETTINGS_SUBSISTENCE_RATE_DELETE_SUCCESS',
  SUBSISTENCE_RATE_DELETE_FAILURE: 'SETTINGS_SUBSISTENCE_RATE_DELETE_FAILURE',
  TOGGLE_EDITOR: 'TOGGLE_SETTINGS_SUBSISTENCE_RATE_EDITOR',
};
